import react, { useState } from "react";
import { translateText } from "../../../../../Helper_functions";
import axios from "axios";

const BotMessageItem = (props) => {
  const [BotMessageAction, setBotMessageAction] = useState(undefined); // undefined OR "LIKE" OR "DISLIKE";

  const toggleLike = (Id) => {
    let Reaction;

    // changing styles to Liked state
    if (BotMessageAction === "LIKE") {
      setBotMessageAction(undefined);
      Reaction = "undo";
    } else {
      setBotMessageAction("LIKE");
      Reaction = "like";
    }

    // making API request to send "like" reaction
    let Req = {
      method: "POST",
      baseURL: window._env_.ASKMEANYTHING_URL + "/reaction",
      data: {
        messageId: Id,
        token: window.localStorage.getItem("Token"),
        reaction: Reaction,
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };
  const toggleDislike = (Id) => {
    let Reaction;

    // changing styles to Disliked state
    if (BotMessageAction === "DISLIKE") {
      setBotMessageAction(undefined);
      Reaction = "undo";
    } else {
      setBotMessageAction("DISLIKE");
      Reaction = "dislike";
    }

    // making API request to send "dislike" reaction
    let Req = {
      method: "POST",
      baseURL: window._env_.ASKMEANYTHING_URL + "/reaction",
      data: {
        messageId: Id,
        token: window.localStorage.getItem("Token"),
        reaction: Reaction,
      },
    };

    axios(Req)
      .then((Res) => {
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const toggleCopy = (Content) => {
    navigator.clipboard.writeText(Content);
    props.DisplayToast();
  };

  return (
    <div className="message-item is-bot">
      <img src={props.AskmMeBotLogo} />
      <section className="message-item-content">
        <p>{props.MessageItem.content}</p>
        <div className="bot-message-actions">
          <button
            className="transparent-btn rounded"
            onClick={() => toggleCopy(props.MessageItem.content)}
          >
            <i className="feather-copy"></i>
            {window.innerWidth >= 451 ? (
              <p className="popup-text">
                {translateText("copy_to_clipboard", props.LangData)}
              </p>
            ) : null}
          </button>

          <button
            onClick={() => toggleDislike(props.MessageItem.id)}
            className={
              BotMessageAction === "DISLIKE" ? "rounded overlayed" : "rounded"
            }
          >
            <i className="feather-thumbs-down"></i>
            {window.innerWidth >= 451 ? (
              <p className="popup-text">
                {translateText("dislike", props.LangData)}
              </p>
            ) : null}
          </button>
          <button
            onClick={() => toggleLike(props.MessageItem.id)}
            className={
              BotMessageAction === "LIKE" ? "rounded overlayed" : "rounded"
            }
          >
            <i className="feather-thumbs-up"></i>
            {window.innerWidth >= 451 ? (
              <p className="popup-text">
                {translateText("like", props.LangData)}
              </p>
            ) : null}
          </button>
        </div>
      </section>
    </div>
  );
};

export default BotMessageItem;
